











import {IContentBlock} from "../../models/shared/content-block";
import AtomParagraph from '../atoms/AtomParagraph.vue';
import {defineComponent, PropType} from "@vue/composition-api";

export default defineComponent({
  name: "MoleculeNotification",
  components: {
    AtomParagraph
  },
  props: {
    contentBlock: {type: Object as PropType<IContentBlock>}
  }
})
